//https://medium.freecodecamp.org/an-introduction-to-the-redux-first-routing-model-98926ebf53cb
import {GO_BACK, PUSH, REPLACE} from '../ducks/duck-router';
import {addModalWindow} from "../ducks/duck-screen";
import {errorModal} from "../helpers/modal-builder";

export default (history) => () => (next) => (action) => {
	// debugger;
	// console.log('LOCATION', history.location)
	switch (action.type) {
		case PUSH:
			if(navigator.onLine === undefined || navigator.onLine){
				history.push(action.payload.href);
			} else {
				return next(addModalWindow(errorModal("error_offline")))
			}
			// console.log('PUSH', action.payload);
			break;
		case GO_BACK:
			history.goBack();
			// if(history.location && history.location.pathname){
			// 	while(history.location.pathname === "/game"){
			// 		history.goBack();
			// 	}
			// }
			// console.log('GO_BACK', history.location);
			break;
		case REPLACE:
			history.replace(action.payload.href);
			// console.log('REPLACE', action.payload);
			break;
		default:
			return next(action);
	}
};